module.exports = __webpack_public_path__ + "static/media/setting.c328f73d.svg";